<script>
import moment from 'moment'
import {
  formatPriceWithSign,
  nToWord
} from '@/utils/helpers'
import starIcon from '@/assets/images/icons/star.svg?inline'
import locationIcon from '@/assets/images/icons/location.svg?inline'
import favoriteToggler from '@/components/services/ui/favoriteToggler.vue'

export default {
  name: 'tours-card',
  components: {
    starIcon,
    locationIcon,
    favoriteToggler
  },
  props: {
    collection: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    form() {
      return this.$store.getters['toursSearch/getForm']
    },
    showAgencyPrice() {
      return this.$store.getters['toursSearch/showAgencyPrice']
    },
    isLoading() {
      return this.$store.getters['toursSearch/isLoading']
        || this.$store.getters['toursSearch/isUpdating']
    },
    isLoadingMore() {
      return this.$store.getters['toursSearch/isLoadingMore']
    },
  },
  methods: {
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
    durationFormat: duration => `${duration} ${nToWord(duration, ['ночь', 'ночи', 'ночей'])}`,
    formatPrice(price, slug) {
      const dictionary = this.$store.getters.getDictionary('toursSearch.dictionaries.currencies')

      return formatPriceWithSign(price, slug, dictionary)
    },
  }
}
</script>
<template>
  <div>
    <div
      v-if="!isLoading"
      class="search-content__cards"
    >
      <div
        v-for="tour in collection"
        :key="`${tour.id}_${tour.tourTemplateId}`"
        class="search-card"
      >
        <div class="search-card__content-line">
          <div class="search-card__image search-card__image--no-border">
            <img
              v-lazyload
              src="@/assets/images/default.jpg"
              :data-src="tour.photo"
            >
          </div>
          <div class="search-card__content">
            <div class="search-card__content-wrap">
              <div>
                <h2 class="search-card__title">
                  {{ tour.hotelName }}
                  <favorite-toggler
                    store-module="hotelsSearch"
                    :hotel-id="tour.id"
                    :search-id="form.hotelSearchId"
                    :favorite-id="tour.favoriteId"
                  />
                </h2>
                <div class="search-card__stars">
                  <starIcon
                    v-for="i in tour.category"
                    :key="`star_${i}`"
                  />
                </div>
                <div class="search-card__facts">
                  <div
                    v-for="(fact, index) in tour.facts.main.slice(0, 3)"
                    :key="`${fact.slug}_${index}`"
                    class="search-card__facts-item"
                  >
                    <img
                      class="search-card__facts-item-image"
                      :src="fact.iconUrl"
                    >
                    <p>{{ fact.name }} {{ fact.value }}</p>
                  </div>
                  <div v-if="tour.facts.main.length > 3">
                    <span class="search-card__facts-more">Показать все</span>
                    <div class="search-card__facts-all">
                      <div
                        v-for="(fact, index) in tour.facts.main"
                        :key="`${fact.slug}_${index}`"
                        class="search-card__facts-item"
                      >
                        <img
                          class="search-card__facts-item-image"
                          :src="fact.iconUrl"
                        >
                        <p>{{ fact.name }} {{ fact.value }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="search-card__content-item search-card__content-item--flex">
                <div>
                  <div
                    v-if="tour.rating"
                    class="search-card__rating"
                  >
                    {{ tour.rating }}/100
                  </div>
                  <a
                    :href="`http://www.google.com/maps/place/${tour.latitude},${tour.longitude}`"
                    target="_blank"
                    class="search-card__location"
                  >
                    <location-icon />
                    <span>{{ tour.city }}</span>
                  </a>
                  <p>
                    {{ tour.tourists }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search-card__content-line">
          <div class="search-card__accomodation-info">
            <div class="search-card__accomodation-info-item">
              <p>Заезд {{ formatDate(tour.startDate) }}</p>
              <p>{{ tour.roomType }}</p>
            </div>
            <div class="search-card__accomodation-info-item">
              <p>{{ durationFormat(tour.accommodationDuration) }}</p>
              <p>{{ tour.mealType }}</p>
            </div>
          </div>
          <div class="search-card__accomodation-info search-card__accomodation-info--space-between">
            <div class="search-card__accomodation-info-item">
              <p>В цену входят</p>
              <div class="search-card__accomodation-info-icons">
                <div class="search-card__accomodation-info-icon">
                  <img src="@/assets/images/icons/car.svg">
                </div>
                <div class="search-card__accomodation-info-icon">
                  <img src="@/assets/images/icons/car.svg">
                </div>
                <div class="search-card__accomodation-info-icon">
                  <img src="@/assets/images/icons/car.svg">
                </div>
              </div>
            </div>
            <div class="search-card__prices">
              <router-link
                :to="{
                  name: 'Cart',
                  params: {
                    id: tour.id,
                    service: 'tours'
                  },
                  query: {
                    placeId: form.placeToId,
                    checkInDate: form.checkInDate,
                    duration: form.duration,
                    flightVariantId: tour.flightVariantId,
                    hotelVariantId: tour.hotelVariantId,
                    transferVariantId: tour.transferVariantId,
                    insuranceVariantId: tour.insuranceVariantId,
                    visaVariantId: tour.visaVariantId,
                    tourTemplateId: tour.tourTemplateId,
                    tourType: tour.tourType,
                    rooms: form.rooms,
                    currency: form.currency,
                    tourResearchForm: {
                      checkInDate: form.checkInDate
                    }
                  }
                }"
                class="search-card__link"
              >
                <span v-if="showAgencyPrice">
                  от
                  {{ formatPrice(tour.price.amount, tour.price.currency) }}
                </span>
                <span v-else>
                  от
                  {{ formatPrice(tour.price.amount - tour.price.markup, tour.price.currency) }}
                </span>
              </router-link>
              <div
                v-if="showAgencyPrice"
                class="search-card__agent-price"
              >
                Комиссия
                <span>{{ formatPrice(tour.price.markup, tour.price.currency) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isLoading || isLoadingMore"
      class="search-content__cards"
    >
      <div
        v-for="item in 10"
        :key="item"
        class="search-card search-card--placeholder"
      >
        <b-loading
          :is-full-page="false"
          :active="true"
        />
      </div>
    </div>
  </div>
</template>